/**
 * @providesModule AnimatedCircularProgress
 * 
 */


import React from "react";
import {AnimatedCircularProgress, AnimatedCircularProgressProps} from 'react-native-circular-progress';
import { Animated } from "react-native";
import CircularProgress from "CircularProgress";

const AnimatedProgress = Animated.createAnimatedComponent(CircularProgress);

type CustomProps = {
  isProgressWithGradient?: boolean;
  beginColor?: string;
  endColor?: string;
  isFillerPadding?:boolean
}

type Props = AnimatedCircularProgressProps & CustomProps;

export default class AnimatedCircularProgressWithGradient extends AnimatedCircularProgress {
  props!: Props;

  render() {
    const { fill, children, isProgressWithGradient, beginColor, endColor, ...other } = this.props;

    return (
      <AnimatedProgress
        {...other}
        // @ts-ignore - fillAnimation is inherited from base component
        fill={this.state.fillAnimation}
        isProgressWithGradient={isProgressWithGradient}
        beginColor={beginColor}
        endColor={endColor}
      >
        {/* @ts-ignore - Type mismatch between base component and our implementation */}
        {children}
      </AnimatedProgress>
    );
  }
}
